import { FSA } from 'flux-standard-action';
import {
  FORM_SUBMISSIONS_FETCH_REQUESTED,
  FORM_SUBMISSIONS_FETCH_SUCCEEDED,
  FORM_SUBMISSIONS_FETCH_FAILED,
  FORM_SUBMISSIONS_SAVE_REQUESTED,
  FORM_SUBMISSIONS_SAVE_SUCCEEDED,
  FORM_SUBMISSIONS_SAVE_FAILED,
  FORM_SUBMISSIONS_DELETE_REQUESTED,
  FORM_SUBMISSIONS_DELETE_SUCCEEDED,
  FORM_SUBMISSIONS_DELETE_FAILED,
} from './action-types';

type state = {
  status: string;
  data: { [key: string]: any };
};

const initialState: state = {
  status: '',
  data: {},
};

export default function reducer(state = initialState, action: FSA<any, any>) {
  switch (action.type) {
    case FORM_SUBMISSIONS_FETCH_REQUESTED:
      return { ...state, status: 'loading' };
    case FORM_SUBMISSIONS_FETCH_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case FORM_SUBMISSIONS_FETCH_FAILED:
      return { ...state, status: 'failed' };

    case FORM_SUBMISSIONS_SAVE_REQUESTED:
      return { ...state, status: 'saving' };
    case FORM_SUBMISSIONS_SAVE_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case FORM_SUBMISSIONS_SAVE_FAILED:
      return { ...state, status: 'failed' };

    case FORM_SUBMISSIONS_DELETE_REQUESTED:
      return { ...state, status: 'deleting' };
    case FORM_SUBMISSIONS_DELETE_SUCCEEDED: {
      const { [action.payload]: _, ...nonDeleted } = state.data;
      return {
        ...state,
        status: 'done',
        data: {
          ...nonDeleted,
        },
      };
    }
    case FORM_SUBMISSIONS_DELETE_FAILED:
      return { ...state, status: 'failed' };

    default:
      return state;
  }
}
